module.exports = require('./lib/Slidy');
